import styled from 'styled-components'

import RotateIcon from 'assets/svgr-icons/Rotate.svg'
import { COLORS } from 'consts/colors'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const MediaControls = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  transform: translateY(calc(-100% - 4px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  gap: 6px;
  background-color: ${COLORS.white};
  border-radius: 4px;
  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    padding: 4px;
  }
`

export const MediaControlItem = styled.div`
  width: 32px;
  height: 24px;
  padding: 4px 8px;
  box-sizing: border-box;
  background-color: ${COLORS.white};
  border-radius: 4px;
  cursor: pointer;

  svg {
    fill: ${COLORS.secondarySemiDark};
  }

  &:hover {
    background-color: ${COLORS.primaryLight};

    svg {
      fill: ${COLORS.secondaryDark};
    }
  }
`

export const MediaControlDivider = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${COLORS.borderColor};
`

export const RotateRightIcon = styled(RotateIcon)`
  transform: scaleX(-1);
`
